/* Appetit theme scripts: cart drawer, search popup, quantity, gallery */
(function () {
  var overlay = null;
  var openPanel = null;
  var lastFocus = null;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function getOverlay() {
    if (!overlay) overlay = qs('[data-overlay]');
    return overlay;
  }

  function openPanelEl(el) {
    if (!el) return;
    closePanel(true);
    lastFocus = document.activeElement;
    var ov = getOverlay();
    el.hidden = false;
    if (ov) ov.hidden = false;
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      if (ov) ov.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    openPanel = el;
    var focusable = qs('[data-autofocus]', el) || qs('button, a, input', el);
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
  }

  function closePanel(silent) {
    var ov = getOverlay();
    if (openPanel) {
      var panel = openPanel;
      panel.classList.remove('is-open');
      setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 380);
    }
    if (ov) {
      ov.classList.remove('is-open');
      setTimeout(function () { if (!ov.classList.contains('is-open')) ov.hidden = true; }, 380);
    }
    document.body.style.overflow = '';
    openPanel = null;
    if (!silent && lastFocus) { lastFocus.focus(); lastFocus = null; }
  }

  document.addEventListener('click', function (e) {
    /* 16 Sep 2026 — new: fills in #ExtraModal from whichever "Add" button was
       clicked, using that button's own data-* attributes. This runs as its
       own, separate click listener — it doesn't touch or replace the
       data-open handler below, which still does the actual showing/hiding
       (data-open="ExtraModal" is set on these same buttons in the liquid). */
    var trigger = e.target.closest('[data-extra-trigger]');
    if (trigger) {
      var modal = qs('#ExtraModal');
      if (!modal) return;
      var media = qs('[data-extra-modal-media]', modal);
      var img = trigger.getAttribute('data-image');
      if (media) {
        media.hidden = !img;
        media.innerHTML = img ? '<img src="' + img + '" alt="">' : '';
      }
      var title = qs('[data-extra-modal-title]', modal);
      if (title) title.textContent = trigger.getAttribute('data-title') || '';
      var price = qs('[data-extra-modal-price]', modal);
      if (price) price.textContent = trigger.getAttribute('data-price') || '';
      var variant = qs('[data-extra-modal-variant]', modal);
      if (variant) variant.value = trigger.getAttribute('data-variant-id') || '';
      var label = qs('[data-extra-modal-label]', modal);
      if (label) label.textContent = trigger.getAttribute('data-message-label') || 'Your message';
      var textarea = qs('[data-extra-modal-textarea]', modal);
      if (textarea) {
        textarea.value = '';
        textarea.placeholder = trigger.getAttribute('data-message-placeholder') || '';
        var max = trigger.getAttribute('data-message-max');
        if (max) textarea.setAttribute('maxlength', max); else textarea.removeAttribute('maxlength');
      }
      var err = qs('[data-form-error]', modal);
      if (err) err.textContent = '';
    }
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openPanelEl(qs('#' + opener.getAttribute('data-open')));
      return;
    }
    if (e.target.closest('[data-close]') || e.target.closest('[data-overlay]')) {
      e.preventDefault();
      closePanel();
    }
    var subToggle = e.target.closest('[data-toggle-sub]');
    if (subToggle) {
      e.preventDefault();
      var item = subToggle.closest('.mobilenav__item');
      if (!item) return;
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      subToggle.setAttribute('aria-expanded', String(!isOpen));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) closePanel();
  });

  /* ---------- cart ----------
     Speed notes:
     - Every cart call asks Shopify to return the re-rendered drawer in the SAME response
       (sections param), so each change is 1 request instead of 3.
     - +/- taps are grouped: the number updates instantly, and one request goes out
       ~350ms after the last tap. Requests run one at a time so answers can't arrive out of order.
     - Only the item list, count and total are swapped. The drawer footer (delivery/pickup
       app widget, gift message, checkout) is left alone, so the app isn't torn down and
       re-injected on every change. */
  var CART_SECTION = 'cart-drawer';
  var cartQueue = Promise.resolve();
  var cartSeq = 0;
  var pendingQty = {};
  var qtyTimers = {};

  function onCartTemplate() { return document.body.classList.contains('template-cart'); }

  function setCartCount(count) {
    qsa('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
      node.hidden = count === 0;
    });
  }

  function renderCartDrawer(sectionHtml, shouldOpen) {
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var freshWrapper = doc.querySelector('#shopify-section-' + CART_SECTION);
    var fresh = doc.querySelector('#CartDrawer');
    var current = qs('#CartDrawer');
    if (!fresh) return;

    var count = parseInt(fresh.getAttribute('data-item-count'), 10) || 0;
    setCartCount(count);

    var wasOpen = !!(openPanel && openPanel.id === 'CartDrawer');
    var canPatch = current && current.querySelector('[data-drawer-foot]') && fresh.querySelector('[data-drawer-foot]');

    if (canPatch) {
      /* Cart still has items: patch in place, keep the footer and scroll position. */
      var body = current.querySelector('[data-drawer-body]');
      var scrollTop = body.scrollTop;
      body.innerHTML = fresh.querySelector('[data-drawer-body]').innerHTML;
      body.scrollTop = scrollTop;
      ['[data-drawer-count]', '[data-drawer-total]'].forEach(function (sel) {
        var a = current.querySelector(sel), b = fresh.querySelector(sel);
        if (a && b) a.textContent = b.textContent;
      });
      current.setAttribute('data-item-count', count);
      if (shouldOpen && !wasOpen) openPanelEl(current);
      return;
    }

    /* Cart went from empty to filled (or the other way): the footer appears/disappears,
       so redraw the whole drawer once. */
    var wrapper = qs('#shopify-section-' + CART_SECTION);
    if (wrapper && freshWrapper) wrapper.innerHTML = freshWrapper.innerHTML;
    var drawer = qs('#CartDrawer');
    if (!drawer) return;
    if (shouldOpen) {
      openPanelEl(drawer);
    } else if (wasOpen) {
      drawer.hidden = false;
      drawer.classList.add('is-open');
      openPanel = drawer;
    }
  }

  /* Fallback: fetch the drawer on its own (used only if a response had no section HTML). */
  function refreshCartDrawer(shouldOpen) {
    return fetch(window.routes.cart_url + '?sections=' + CART_SECTION, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data[CART_SECTION]) renderCartDrawer(data[CART_SECTION], shouldOpen); });
  }

  var ADDED_DISPLAY_MS = 2500; /* how long the "Added" confirmation stays up */

  /* The main product button's label lives in a nested [data-add-to-cart-text]
     span (so the variant picker can rewrite just the text); other data-cart-add
     buttons (extras grid, the #ExtraModal popup) are plain buttons with no such
     span. Always resolve to whichever element actually holds the label so we
     never clobber the span itself. */
  function labelTarget(btn) {
    if (!btn) return null;
    return btn.querySelector('[data-add-to-cart-text]') || btn;
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = busy;
    var target = labelTarget(btn);
    if (busy) {
      target.dataset.label = target.textContent;
      target.textContent = 'Adding';
    }
  }

  /* 16 Sep 2026 — new: on success, show "Added" for a beat, then restore the
     button's original label and re-enable it. onDone fires once that beat is
     over, so callers (the #ExtraModal handler below) can time a popup close
     to happen right after the confirmation, instead of the popup closing
     out from under the confirmation. */
  function setAdded(btn, onDone) {
    if (!btn) { if (onDone) onDone(); return; }
    var target = labelTarget(btn);
    target.textContent = (window.themeStrings && window.themeStrings.added) || 'Added';
    setTimeout(function () {
      target.textContent = target.dataset.label || target.textContent;
      btn.disabled = false;
      if (onDone) onDone();
    }, ADDED_DISPLAY_MS);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var inModal = !!form.closest('#ExtraModal');
    setBusy(btn, true);
    var body = new FormData(form);
    body.append('sections', CART_SECTION);
    body.append('sections_url', window.location.pathname);
    cartSeq++;
    cartQueue = cartQueue.then(function () {
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          var msg = form.querySelector('[data-form-error]');
          if (msg) msg.textContent = '';
          if (res.sections && res.sections[CART_SECTION]) renderCartDrawer(res.sections[CART_SECTION], true);
          else refreshCartDrawer(true);
          /* 16 Sep 2026 — show "Added" on the button first; the popup (if any)
             only closes once that confirmation has had its moment on screen. */
          setAdded(btn, function () {
            if (inModal) closePanel();
          });
        })
        .catch(function (err) {
          var msg = form.querySelector('[data-form-error]');
          if (msg) msg.textContent = err.message;
          setBusy(btn, false);
        });
    });
  });

  function markLine(key, busy) {
    qsa('.cartline[data-line]').forEach(function (line) {
      if (line.getAttribute('data-line') === key) line.classList.toggle('is-updating', busy);
    });
  }

  function sendLineChange(key, quantity) {
    var seq = ++cartSeq;
    cartQueue = cartQueue.then(function () {
      return fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: CART_SECTION, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (onCartTemplate()) { window.location.reload(); return; }
          if (cart.status) return refreshCartDrawer(false); /* e.g. not enough stock: show the real cart */
          /* A newer change is already queued or waiting: skip this redraw, the newer one will draw. */
          if (seq !== cartSeq || Object.keys(pendingQty).length) return;
          if (cart.sections && cart.sections[CART_SECTION]) renderCartDrawer(cart.sections[CART_SECTION], false);
          else return refreshCartDrawer(false);
        })
        .catch(function () { return refreshCartDrawer(false); });
    });
    return cartQueue;
  }

  function queueLineChange(key, quantity, delay) {
    pendingQty[key] = quantity;
    clearTimeout(qtyTimers[key]);
    if (quantity === 0) markLine(key, true);
    qtyTimers[key] = setTimeout(function () {
      var q = pendingQty[key];
      delete pendingQty[key];
      delete qtyTimers[key];
      markLine(key, true);
      sendLineChange(key, q);
    }, delay);
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      queueLineChange(remove.getAttribute('data-cart-remove'), 0, 0);
      return;
    }
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var wrap = step.closest('.qty');
      var input = wrap.querySelector('input');
      var next = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
      if (String(next) === input.value) return;
      input.value = next;
      if (wrap.hasAttribute('data-cart-line')) queueLineChange(wrap.getAttribute('data-cart-line'), next, 350);
    }
  });

  document.addEventListener('change', function (e) {
    var wrap = e.target.closest('.qty[data-cart-line]');
    if (!wrap) return;
    queueLineChange(wrap.getAttribute('data-cart-line'), Math.max(0, parseInt(e.target.value, 10) || 0), 0);
  });

  /* ---------- gift message (saved as the order note) ---------- */
  var noteTimer;
  function saveCartNote(value) {
    clearTimeout(noteTimer);
    return fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ note: value })
    }).catch(function () {});
  }

  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    var counter = note.parentNode.querySelector('[data-note-count]');
    if (counter) counter.textContent = note.value.length;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { saveCartNote(note.value); }, 600);
  });

  /* Save straight away when the box loses focus (e.g. the customer taps Checkout). */
  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (note) saveCartNote(note.value);
  });

  /* ---------- predictive search ---------- */
  var searchTimer;
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-search-input]');
    if (!input) return;
    var results = qs('[data-search-results]');
    clearTimeout(searchTimer);
    var term = input.value.trim();
    if (term.length < 2) {
      results.innerHTML = '<p class="searchpop__hint">Type at least two letters to search.</p>';
      return;
    }
    searchTimer = setTimeout(function () {
      var url = window.routes.predictive_search_url +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,page&resources[limit]=8&section_id=predictive-search';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-predictive-inner]');
          results.innerHTML = fresh ? fresh.innerHTML : '<p class="searchpop__hint">Nothing found.</p>';
        });
    }, 250);
  });

  /* ---------- product gallery ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery.querySelector('[data-gallery-main] img');
    if (main) {
      main.src = thumb.getAttribute('data-src');
      main.srcset = '';
      main.alt = thumb.getAttribute('data-alt') || '';
    }
    qsa('[data-gallery-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
    thumb.setAttribute('aria-current', 'true');
  });

  /* ---------- collection filters/sort ---------- */
  document.addEventListener('change', function (e) {
    var control = e.target.closest('#CollectionFilterForm [data-auto-submit], #CollectionFilterForm input[type="checkbox"]');
    if (control) control.closest('form').submit();
  });

  /* ---------- price range slider ---------- */
  function formatMoneyMajor(amountMajor, format) {
    var amount = parseFloat(amountMajor).toFixed(2);
    if (format && format.indexOf('{{amount}}') !== -1) return format.replace('{{amount}}', amount);
    if (format && format.indexOf('{{ amount }}') !== -1) return format.replace('{{ amount }}', amount);
    return amount;
  }

  function updatePriceRangeUI(container) {
    var minInput = container.querySelector('[data-price-slider-min]');
    var maxInput = container.querySelector('[data-price-slider-max]');
    var fill = container.querySelector('[data-price-fill]');
    var minLabel = container.querySelector('[data-price-min-label]');
    var maxLabel = container.querySelector('[data-price-max-label]');
    var rangeMax = parseFloat(minInput.max) || 1;
    var min = parseFloat(minInput.value);
    var max = parseFloat(maxInput.value);
    if (fill) {
      fill.style.left = (min / rangeMax * 100) + '%';
      fill.style.right = (100 - (max / rangeMax * 100)) + '%';
    }
    var format = container.getAttribute('data-money-format');
    if (minLabel) minLabel.textContent = formatMoneyMajor(min, format);
    if (maxLabel) maxLabel.textContent = formatMoneyMajor(max, format);
  }

  document.addEventListener('input', function (e) {
    var slider = e.target.closest('[data-price-slider-min], [data-price-slider-max]');
    if (!slider) return;
    var container = slider.closest('[data-price-range]');
    var minInput = container.querySelector('[data-price-slider-min]');
    var maxInput = container.querySelector('[data-price-slider-max]');
    if (parseFloat(minInput.value) > parseFloat(maxInput.value)) {
      if (slider === minInput) minInput.value = maxInput.value;
      else maxInput.value = minInput.value;
    }
    updatePriceRangeUI(container);
  });

  qsa('[data-price-range]').forEach(updatePriceRangeUI);

  /* ---------- variant picker ---------- */
  document.addEventListener('change', function (e) {
    var picker = e.target.closest('[data-variant-picker]');
    if (!picker) return;
    var form = picker.closest('form');
    var idInput = form.querySelector('[data-variant-id]');
    if (idInput) idInput.value = picker.value;

    var option = picker.options[picker.selectedIndex];
    if (!option) return;

    var priceEl = qs('#ProductPrice');
    if (priceEl && option.getAttribute('data-price')) priceEl.textContent = option.getAttribute('data-price');

    var available = option.getAttribute('data-available') === 'true';
    var addBtn = form.querySelector('[data-add-to-cart-button]');
    if (addBtn) {
      addBtn.disabled = !available;
      var label = addBtn.querySelector('[data-add-to-cart-text]');
      if (label) label.textContent = available ? window.themeStrings.addToBasket : window.themeStrings.soldOut;
    }
  });
})();

/* Sticky-on-scroll header + announcement bar: once scrolled past a small
   threshold, the announcement bar locks to the very top and the header
   locks in right below it (instead of both landing on top of each other).
   Each element's wrapper gets its height held explicitly while stuck, so
   the page doesn't jump when they leave normal flow. */
(function () {
  var header = document.querySelector('.header');
  if (!header) return;
  var announcement = document.querySelector('.announcement');
  var headerWrapper = header.parentElement;
  var annWrapper = announcement ? announcement.parentElement : null;
  var STICK_AFTER = 20; /* px scrolled before it locks — adjust as needed */
  var ticking = false;

  function applyState() {
    var shouldStick = window.scrollY > STICK_AFTER;
    var isStuck = header.classList.contains('sticky');
    if (shouldStick !== isStuck) {
      if (shouldStick) {
        var headerH = header.offsetHeight;
        var annH = announcement ? announcement.offsetHeight : 0;

        if (announcement) {
          announcement.classList.add('sticky');
          if (annWrapper) annWrapper.style.height = annH + 'px';
        }
        header.classList.add('sticky');
        header.style.top = annH + 'px';
        if (headerWrapper) headerWrapper.style.height = headerH + 'px';
      } else {
        if (announcement) {
          announcement.classList.remove('sticky');
          if (annWrapper) annWrapper.style.height = '';
        }
        header.classList.remove('sticky');
        header.style.top = '';
        if (headerWrapper) headerWrapper.style.height = '';
      }
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(applyState); }
  }, { passive: true });

  applyState();
})();
